"use strict";
angular.module('checkPhoneAndEmail', []).
factory('checkPhoneAndEmail', ['$modal', "$compile", "$timeout","httpService","$q", function($modal, $compile, $timeout,httpService,$q) {
        return {
            checkPhone: function(obj) {
            	var deferred = $q.defer();
            	var phoneReg = /^(1[2-9][0-9])\d{8}$/;  
				if (phoneReg.test(obj.param)) {
					if(obj.oldValue != obj.param){
						httpService.http("/mcnww/web/user/existsValid.do",obj, "post").then(function(data) {
							var flag = true;
							if(data.status === 'n'){
								flag = false;
							}
							 deferred.resolve(flag);
						});
					}
				}
                return deferred.promise;
            },
            checkEmail: function(obj) {
            	var deferred = $q.defer();
            	var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/; 
				if(reg.test(obj.param)){
				 	if(obj.oldValue != obj.param){
				 		httpService.http("/mcnww/web/user/existsValid.do",obj, "post").then(function(data) {
				 			var flag = true;
							if(data.status === 'n'){
								flag = false;
							}
							 deferred.resolve(flag);
				 		});
				 	}
				}
				return deferred.promise;
            }
        };
}]);
